var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-descriptions-item',{attrs:{"label":_vm.label,"span":_vm.span,"label-class-name":_vm.labelClassName,"content-class-name":_vm.mcontentClassName,"label-style":_vm.labelStyle,"content-style":_vm.contentStyle}},[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }